import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { MeetingPrepStoryRemovalReason } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const RemoveMeetingPrepStoryMutation = graphql(`
  mutation RemoveMeetingPrepStory($input: RemoveMeetingPrepStoryInput!) {
    removeMeetingPrepStory(input: $input) {
      id
      __typename
      clientId
      storyKey
    }
  }
`);

export interface RemoveMeetingPrepStoryInput {
  clientId: string;
  storyKey: string;
  reason: MeetingPrepStoryRemovalReason;
  reasonText?: string;
  /** Serialized StoryCard JSON snapshot as rendered. */
  storyCard?: string;
}

export function useRemoveMeetingPrepStory() {
  const [result, removeMeetingPrepStoryMutation] = useMutation(RemoveMeetingPrepStoryMutation);
  const [error, setError] = useState<Error | null>(null);

  const removeMeetingPrepStory = useCallback(
    async (input: RemoveMeetingPrepStoryInput) => {
      try {
        const response = await removeMeetingPrepStoryMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.removeMeetingPrepStory;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [removeMeetingPrepStoryMutation],
  );

  return { removeMeetingPrepStory, result, error };
}
